import React from 'react';
import { ChatActivity } from '../../store/chatStore';

interface ActivityLogProps {
  activities: ChatActivity[];
  live?: boolean;
}

const StatusIcon: React.FC<{ status: ChatActivity['status'] }> = ({ status }) => {
  if (status === 'active') {
    return <span className="text-blue-400 animate-pulse text-[10px]">&#9679;</span>;
  }
  if (status === 'error') {
    return <span className="text-red-400 text-[10px]">&#10007;</span>;
  }
  return <span className="text-emerald-400 text-[10px]">&#10003;</span>;
};

const ActivityLog: React.FC<ActivityLogProps> = ({ activities, live = false }) => {
  if (!activities || activities.length === 0) return null;

  return (
    <div className="mb-1">
      {activities.map((a) => (
        <div key={a.id} className={`flex items-center gap-1.5 text-xs leading-relaxed ${
          a.status === 'active'
            ? 'text-blue-400'
            : a.status === 'error'
            ? 'text-red-400'
            : 'text-neutral-500'
        }`}>
          <StatusIcon status={a.status} />
          <span>{a.message}</span>
        </div>
      ))}
    </div>
  );
};

export default ActivityLog;
